import { render, staticRenderFns } from "./VoidTag.vue?vue&type=template&id=fac5ceec&scoped=true&"
import script from "./VoidTag.vue?vue&type=script&lang=js&"
export * from "./VoidTag.vue?vue&type=script&lang=js&"
import style0 from "./VoidTag.vue?vue&type=style&index=0&id=fac5ceec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac5ceec",
  null
  
)

export default component.exports